export default __webpack_public_path__ + "static/media/draw-polygon.3c85df83.svg";